import { render, staticRenderFns } from "./LabelStatementsReadonly.vue?vue&type=template&id=1cfc1a84"
import script from "./LabelStatementsReadonly.vue?vue&type=script&lang=js"
export * from "./LabelStatementsReadonly.vue?vue&type=script&lang=js"
import style0 from "./LabelStatementsReadonly.vue?vue&type=style&index=0&id=1cfc1a84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports